
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Modal, Box, IconButton } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import apiCumbres from "../axios/axios";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import { styleBtn, sxTableHead, textFieldStyle } from "./Styles";
import Swal from "sweetalert2";



const ModalPagosPrestmo = ({ open, onClose, idp }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [pagosPrestamo, setPagosPrestamo] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pagarSoloInteres, setPagarSoloInteres] = useState(false)


    const buscarPagosPrestamo = () => {

        const buscar = async () => {
            try {
                setIsLoading(true)
                const pagosPrestamo = await apiCumbres.get(`/revisar-prestamos/pagos-prestamo/${idp}`)

                setPagosPrestamo(pagosPrestamo.data.pagos)
                setPagarSoloInteres(pagosPrestamo.data.solo_interes)

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener pagos de préstamo, favor de volver a recargar!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                onClose()
                toast.error(msg_error, toast_config)
            }

        }

        buscar()

    }


    useEffect(() => {
        if (open) buscarPagosPrestamo()

        if (!open) {
            setPage(0)
            setRowsPerPage(5)
            setPagosPrestamo([])
        }

    }, [open])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //VER COMO PASAR EL ID, YA QUE LLEGA UNDEFINED

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate().toString().padStart(2, '0')} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    const formatFechaAbonado = (value) => {
        const fecha = new Date(value)
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`
    }

    const abonarPago = (e, id, fecha, fc, fi) => {
        onClose()
        const checkMora = `
            <label style="display:flex;align-items:center;gap:8px;margin-bottom:12px;font-weight:600;">
                <input id="checkMora" type="checkbox" />
                Aplicar mora
            </label>
            `;

        const btnAbonoCompleto = `<button id="completo" style="background:#0a2540;color:#fff;border:none;border-radius:6px;padding:10px 16px;font-weight:600;cursor:pointer;" onmouseover="this.style.opacity='0.85'" onmouseout="this.style.opacity='1'">Abono Completo</button>`
        const btnAbonoCapital = pagarSoloInteres ? `<button id="capital" style="background:#1e88e5;color:#fff;border:none;border-radius:6px;padding:10px 16px;font-weight:600;cursor:pointer;" onmouseover="this.style.opacity='0.85'" onmouseout="this.style.opacity='1'">Abono Capital</button>` : ''
        const btnAbonoInteres = pagarSoloInteres ? `<button id="interes" style="background:#9e9e9e;color:#fff;border:none;border-radius:6px;padding:10px 16px;font-weight:600;cursor:pointer;" onmouseover="this.style.opacity='0.85'" onmouseout="this.style.opacity='1'">Abono Interes</button>` : ''

        Swal.fire({
            title: "Selecciona una opción",
            html: `
            ${(!fc && !fi) ? checkMora : ''}
              <div style="display:flex; flex-direction:column; gap:8px">
                ${fc || fi ? '' : btnAbonoCompleto}
                ${fc ? '' : btnAbonoCapital}
                ${fi ? '' : btnAbonoInteres}
              </div>
            `,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonColor: "#d33",
            didOpen: () => {

                const tieneMora = () => {
                    const check = document.getElementById('checkMora');
                    return check ? check.checked : false;
                };

                if (!fc && !fi) {
                    document.getElementById("completo").onclick = () => {
                        Swal.close();
                        abonarPagoOpcion('COMPLETO', fecha, id, tieneMora())
                    };
                }

                if (!fc && pagarSoloInteres) {
                    document.getElementById("capital").onclick = () => {
                        Swal.close();
                        abonarPagoOpcion('CAPITAL', fecha, id, false)
                    };
                }

                if (!fi && pagarSoloInteres) {
                    document.getElementById("interes").onclick = () => {
                        Swal.close();
                        abonarPagoOpcion('INTERESES', fecha, id, false)
                    };
                }

            }
        });




    }

    const abonarPagoOpcion = (abono, fecha, id, mora) => {

        Swal.fire({
            title: "Está seguro?",
            text: `Se abonará ${abono} del pago de ${fecha}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, abonar!"
        }).then((result) => {
            if (!result.isConfirmed) return

            const abonar = async () => {

                try {
                    setIsLoading(true)

                    const abonando = await apiCumbres.put(`/revisar-prestamos/abonar-pago/${id}?tipoabono=${abono}&mora=${mora}`)
                    setIsLoading(false)

                    Swal.fire({
                        icon: 'success',
                        title: 'Enhorabuena!',
                        text: abonando.data.mensaje
                    }).then((result) => {
                        window.location.href = '/revisar-prestamos'
                    })

                } catch (error) {
                    let msg_error = ''
                    if (error.response) {
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al hacer pago de préstamo, favor de volver a recargar!'
                        }
                    } else {
                        console.log(error)
                        msg_error = 'No hay respuesta por parte del servidor!'
                    }
                    //mensaje de toastify
                    setIsLoading(false)

                    toast.error(msg_error, toast_config)
                }

            }

            abonar()

        });

    }

    const liquidarPrestamo = () => {
        onClose()
        Swal.fire({
            title: "Está seguro?",
            text: `Se liquidara prestamo`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, liquidar!"
        }).then((result) => {
            if (!result.isConfirmed) return

            const liquidar = async () => {

                try {
                    setIsLoading(true)
                    const liquidarPagos = await apiCumbres.put(`/revisar-prestamos/liquidar/${idp}`)
                    setIsLoading(false)

                    Swal.fire({
                        icon: 'success',
                        title: 'Enhorabuena!',
                        text: liquidarPagos.data.mensaje
                    }).then((result) => {
                        window.location.href = '/revisar-prestamos'
                    })

                } catch (error) {
                    let msg_error = ''
                    if (error.response) {
                        console.log(error.response)
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al liquidar préstamo, favor de volver a recargar!'
                        }
                    } else {
                        console.log(error)
                        msg_error = 'No hay respuesta por parte del servidor!'
                    }
                    //mensaje de toastify
                    setIsLoading(false)
                    onClose()
                    toast.error(msg_error, toast_config)
                }

            }

            liquidar()


        });




    }

    return (
        <>
            <AnimatePresence>

                {open && (
                    <Modal
                        open={open}
                        onClose={onClose}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <>
                            {isLoading ?
                                <LoadingSpinner />
                                : null}
                            {/* BACKDROP ANIMADO */}
                            <motion.div
                                key="backdrop"
                                initial={{ opacity: 0, backdropFilter: "blur(0px)" }}
                                animate={{ opacity: 1, backdropFilter: "blur(4px)" }}
                                exit={{ opacity: 0, backdropFilter: "blur(0px)" }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    position: "fixed",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.45)",
                                    zIndex: -1
                                }}
                                onClick={onClose}
                            />

                            <motion.div
                                initial={{ opacity: 0, scale: 0.6, rotate: -3 }}
                                animate={{ opacity: 1, scale: 1, rotate: 0 }}
                                exit={{ opacity: 0, scale: 0.8, rotate: 2 }}
                                transition={{
                                    duration: 0.35,
                                    ease: [0.25, 0.8, 0.25, 1]
                                }}
                                style={{ outline: "none" }}
                            >
                                <Box
                                    sx={{
                                        width: "min(1200px, 95vw)",
                                        maxHeight: "90vh",     // 🔑 permite crecer o encogerse
                                        minHeight: "300px",
                                        bgcolor: "background.paper",
                                        borderRadius: "12px",
                                        boxShadow: 24,
                                        position: "relative",
                                        mx: "auto",
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* TACHITA */}
                                    <IconButton
                                        onClick={onClose}
                                        sx={{ position: "absolute", top: 8, right: 8 }}
                                    >
                                        <HighlightOffIcon className="text-danger" />
                                    </IconButton>
                                    <Box sx={{ p: 3, flexShrink: 0 }}>
                                        <motion.h1 className="color-primary"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -20 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}>
                                            Pagos Préstamo
                                        </motion.h1>
                                        <hr className="mb-5" />


                                        <Button size="small" variant="contained" fullWidth className="mb-3" sx={styleBtn} onClick={liquidarPrestamo}>Liquidación Anticipada</Button>
                                    </Box>


                                    <Box
                                        sx={{
                                            flex: 1,
                                            overflowY: "auto",   // 🔥 aquí vive el scroll vertical
                                            overflowX: "hidden",
                                            minWidth: 0,
                                            px: 3,
                                            pb: 2,
                                        }}
                                    >

                                        <TableContainer component={Paper} sx={{
                                            width: "100%",
                                            overflowX: "auto",   // 🔥 horizontal
                                            overflowY: "visible",
                                        }}>
                                            <Table sx={{ minWidth: 900 }} >
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                        <TableCell sx={sxTableHead}>#</TableCell>
                                                        <TableCell sx={sxTableHead}>Fecha Abono</TableCell>
                                                        <TableCell sx={sxTableHead}>Monto</TableCell>
                                                        <TableCell sx={sxTableHead}>Monto Abonado</TableCell>
                                                        <TableCell sx={sxTableHead}>Pagado</TableCell>
                                                        <TableCell sx={sxTableHead}>Fecha Abonado</TableCell>
                                                        <TableCell sx={sxTableHead}>Abonar</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <AnimatePresence component={null}>
                                                        {pagosPrestamo
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pp, index) => (
                                                                <motion.tr
                                                                    key={index}
                                                                    initial={{ opacity: 0, x: -50 }}
                                                                    animate={{ opacity: 1, x: 0 }}
                                                                    exit={{ opacity: 0, y: -40 }}
                                                                    transition={{
                                                                        duration: 0.4,
                                                                        ease: "easeOut",
                                                                        delay: 0.1 * index
                                                                    }}
                                                                    style={{
                                                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                    }}
                                                                >
                                                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                                    <TableCell>{formatFecha(pp.fechaAbono)}</TableCell>
                                                                    <TableCell>${formatNumber(pp.monto)}</TableCell>
                                                                    <TableCell>${pp.abonoPagado || pp.fechaAbonadoCapital || pp.fechaAbonadoInteres ? formatNumber(pp.montoAbonadoFinal) : '0.00'}</TableCell>
                                                                    <TableCell className={pp.abonoPagado ? 'text-success' : 'text-danger'}>
                                                                        {pp.abonoPagado ? 'ABONADO' : 'FALTANTE'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {pp.fechaAbonado ? (
                                                                            formatFechaAbonado(pp.fechaAbonado)
                                                                        ) : (
                                                                            'N/A'
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {pp.abonoPagado ? (
                                                                            'N/A'
                                                                        ) : (
                                                                            <Button size="small" variant="contained" fullWidth sx={styleBtn} onClick={(e) => abonarPago(e, pp.pagoId, formatFecha(pp.fechaAbono), pp.fechaAbonadoCapital, pp.fechaAbonadoInteres)}>PAGAR</Button>
                                                                        )}
                                                                    </TableCell>
                                                                </motion.tr>
                                                            ))}
                                                    </AnimatePresence>
                                                </TableBody>
                                            </Table>
                                            <Box sx={{ flexShrink: 0 }}>
                                                <TablePagination
                                                    component="div"
                                                    count={pagosPrestamo.length}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    rowsPerPage={rowsPerPage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    labelRowsPerPage="Registros por página"
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                />
                                            </Box>
                                        </TableContainer>
                                    </Box>


                                </Box>
                            </motion.div>
                        </>
                    </Modal>
                )}

            </AnimatePresence>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </>

    )

}

export default ModalPagosPrestmo

